(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/company-details-provider.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/company-details-provider.js');
"use strict";


const {
  createContext,
  useReducer
} = React;
const {
  reducer,
  initializer,
  initialState
} = svs.ticket_partner.companyDetails;
const CompanyDetailsContext = createContext();
svs.ticket_partner.CompanyDetailsContext = CompanyDetailsContext;
const CompanyDetailsProvider = _ref => {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(reducer, initialState, initializer);
  return React.createElement(CompanyDetailsContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, children);
};
svs.ticket_partner.CompanyDetailsProvider = CompanyDetailsProvider;

 })(window);